/**
 * File: aria-list.js
 *
 * Import and initialize functions for zoom accessibility issue
 */

 export default {
	init() {
		this.render();
	},
	render() {
		const lists = document.querySelectorAll('ol, ul');
		const listItems = document.querySelectorAll('li');

		lists.forEach(list => list.setAttribute('role', 'list'));
		listItems.forEach(item => item.setAttribute('role', 'listitem'));
	},
  };
